import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 1000px;
  height: auto;
  position: relative;
  padding: 52px 60px 32px 60px;
  display: flex;
  flex-direction: column;

  background-color: ${({ theme }) => theme.colors.grey.black};
  border-radius: 32px;
  overflow: hidden;

  @media ${({ theme }) => theme.devices.mobile} {
    width: 100vw;
    max-width: 100vw;
    height: 100%;
    padding: 20px 16px;
    position: fixed;
    top: 0;
    border-radius: 0;
  }
`;

export const ButtonClose = styled.button`
  width: 32px;
  background-color: transparent;
  position: absolute;
  border: 0;
  top: 16px;
  right: 16px;

  img {
    width: 100%;
  }
`;

export const Top = styled.div`
  width: 100%;
  position: relative;

  @media ${({ theme }) => theme.devices.mobile} {
    margin-top: 40px;
  }

  input {
    width: 100%;
    border-radius: 32px;
    padding: 16px 36px 16px 16px;
    font-size: 20px;
    position: relative;
    text-align: center;
    color: ${({ theme }) => theme.colors.grey.white};
    border: 1.5px solid rgba(255, 255, 255, 0.1);
    background: linear-gradient(
      263deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.2) 100%
    );

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 16px;
      padding: 8px 36px 8px 12px;
    }

    &::placeholder {
      color: ${({ theme }) => theme.colors.grey.white};
      opacity: 0.5;
    }
  }

  > img {
    width: 38px;
    color: ${({ theme }) => theme.colors.grey.white};
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);

    @media ${({ theme }) => theme.devices.mobile} {
      width: 24px;
    }
  }
`;

export const Body = styled.div`
  width: 100%;
  margin-top: 28px;

  > a {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 16px 20px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey[500]};

    img {
      width: 20px;
      color: ${({ theme }) => theme.colors.primary.light};

      @media ${({ theme }) => theme.devices.mobile} {
        width: 20px;
      }
    }

    p {
      margin-bottom: -4px;

      span {
        font-size: 16px;
        margin-left: 6px;
        font-weight: 700;
      }
    }

    &:hover {
      transition: 0.7s;
      background-color: ${({ theme }) => theme.colors.grey[600]};
      color: ${({ theme }) => theme.colors.primary.light};
    }
  }
`;

export const Recommended = styled.div`
  width: 100%;
  display: flex;
  gap: 12px;
  margin-top: 8px;

  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
  }

  a {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    gap: 12px;
    padding: 20px;
    z-index: 0;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 20px;
      padding: 1px;
      background: ${({ theme }) => theme.colors.gradient.fullX};
      -webkit-mask: linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      z-index: -1;
    }

    &:hover {
      transition: 0.7s;
      border-radius: 20px;
      background-color: ${({ theme }) => theme.colors.grey[700]};
    }

    @media ${({ theme }) => theme.devices.mobile} {
      justify-content: flex-start;
      padding: 16px;
    }

    img {
      width: 20px;
    }

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;

      span {
        font-size: 14px;
        text-align: center;
      }
    }
  }
`;

export const Empty = styled.div`
  width: 100%;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;

  img {
    width: 100%;
    max-width: 80px;
  }
`;

export const Ads = styled.div`
  width: 100%;
  margin-top: 8px;
`;
